export const languageStringsCampaign = {
  leavingWithChanges:
    "Nem mentette el a kampány módosításait. Vissza szeretné állítani?",
  addFirstCampaign: "Adja hozzá az első kampányát",
  setUpFirstCampaign:
    "Állítsa be az első kampányát és kezdjen el pénzt keresni.",
  addCampaign: "Kampány hozzáadása",
  addNotification: "Értesítés hozzáadása",
  deleteCampaign: "Törli a kampányt?",
  preview: "Előnézet",
  unnamedCampaign: "(névtelen)",
  table: {
    name: "Név",
    creationDate: "Létrehozva",
    notificationCount: "Értesítések",
    status: "Állapot",
    delete: "Törlés",
  },
  settings: {
    all: "MEGJELENÍTÉS MINDENHOL",
    custom: "EGYEDI KIVÁLASZTÁS",
    title: "Megjelenítés",
    campaignName: "Kampány neve",
    setCampaign: "Kampány beállítása",
    newCampaign: "Új kampány",
    whereWillCampaignBeShown: "Hol fog megjelenni a kampány",
    allDescription:
      'Az értesítések az egész weboldalon megjelennek. Ha ki szeretne zárni bizonyos oldalakat az értesítések megjelenítéséből, vagy csak konkrét oldalakat szeretne meghatározni, ahol ennek a kampánynak az értesítései megjelennek, válassza az „Egyedi kiválasztás" opciót.',
    url: {
      title: "weboldal link (URL)",
      startsWith: "Ezzel kezdődik",
      includes: "Tartalmazza",
      equals: "Megegyezik",
    },
    includes: "Tartalmazza",
    exclude: "Kizárja (opcionális)",
    addCondition: "Feltétel hozzáadása",
  },
  design: {
    title: "Eszközök",
    notificationsDesign: "Értesítések megjelenése",
    designDescription:
      "Beállítások az egész kampányra, az egyes értesítések megjelenését az értesítések beállításaiban módosíthatja.",
    computerOff: "Az értesítések nem jelennek meg asztali eszközökön (PC)",
    mobileOff: "Az értesítések nem jelennek meg mobil eszközökön",
    computer: "Megjelenítés számítógépen",
    mobile: "Megjelenítés mobilon",
    position: "Pozíció",
    downLeftCorner: "Bal alsó sarok",
    downRightCorner: "Jobb alsó sarok",
    upLeftCorner: "Bal felső sarok",
    upRightCorner: "Jobb felső sarok",
    down: "Lent",
    up: "Fent",
    animations: "Animáció",
    playAnimation: "Animáció lejátszása",
    animationSettings: {
      showAfter: "Értesítés megjelenítése ennyi idő elteltével",
      showDelay: "Megjelenítés időtartama",
      delayBetween: "Értesítések közötti késleltetés",
      showSpeed: "Megjelenítés gyorsasága",
      second: "másodperc",
      seconds: "másodpercekben",
    },
  },
  notifications: {
    title: "Értesítések",
    noNotifications: "Egyelőre nincsenek értesítései",
    addNewNotification: "Értesítés hozzáadása",
    addNotificationHelperText:
      "Válasszon ki és kattintson legalább az egyikre a 8 megjelenített mező (értesítési típusok) közül",
    table: {
      type: "Típus",
      preview: "Előnézet",
      status: "Kikapcsolva / Bekapcsolva",
    },
    settings: {
      customization: {
        title: "Beállítások",
      },
      displayRules: {
        title: "Megjelenítési szabályok",
        text: "Szöveg",
        notificationText: "Értesítés szövege",
        variant: "Változat",
        choseVariant: "Változat kiválasztása",
        days: "nap",
        h: "ó",
        addKey: "API kulcs hozzáadása",
        show: "Megjeleníti",
        notificationName: "Értesítés neve",
        nameNotification: "Adjon nevet az értesítésnek",
        repeatNotification: "Értesítések ismétlései",
        fillNotificationText: "Adja meg az értesítés szövegét",
        actualVisitors: {
          nameVisitors: "Nevezze meg a látogatókat",
          visitors: "látogatók",
          maxVisitors: "Minimális látogatók száma a megjelenítéshez",
        },
        lastOrders: {
          maxLast: "Legfeljebb az utolsó",
          maxToShow: "Megjelenítéshez a minimális mennyiség",
          whenAtLeast: "Értesítés csak akkor, ha legalább",
          ordersLast: "Megrendelés az utolsó",
          haveOrderedPlaceholder: "már rendelt. És Ön?",
          showOwnOrders: "Saját megrendelések megmutatása a látogatóknak",
          notRecoginzed: 'Fel nem ismert nevek, mint "Ügyfél"',
          orders: "megrendelések",
        },
        lastRegistrations: {
          maxLast: "Legfeljebb az utolsó",
          registrations: "regisztrációk",
          notRecoginzed: 'Fel nem ismert nevek, mint "Látogató"',
          registrationsLast: "Regisztráció az utolsó",
          showOwnRegistrations: "Saját regisztráció bemutatása a látogatóknak",
          isRegistredPlaceholder: "befejezte a regisztrációt",
        },
        visitorSummary: {
          visitors: "Látogatók",
          registrations: "Regisztrációk",
          orders: "Megrendelések",
          visitors2: "látogatók",
          registrations2: "regisztrációk",
          orders2: "megrendelések",
          last: "az utolsó",
          minNumber: "Minimális szám",
          toShow: "a megjelenítéshez",
        },
        individual: {
          link: "Link",
          button: "Gomb",
          buttonName: "Gomb elnevezése",
          url: "Célweboldal hivatkozása (URL)",
          buttonAsLink: "Link gombként",
          textColor: "Szöveg színe",
          openLinkInNewWindow: "Link megnyitása új ablakban",
          buttonColor: "Gomb színe",
          removedLinkDescription:
            "A link eltávolítása hosszabb értesítési szöveget tesz lehetővé.",
          tooLongTextErrorMessage: "A szöveg túllépi a maximális hosszúságot.",
          tooltip:
            "Adja meg a teljes URL-címet, beleértve a http://, https:// előtagot is. Ha például a https://www.seznam.cz hivatkozást adja meg ebben a mezőben, a látogatók a gombra kattintva átirányításra kerülnek a https://www.seznam.cz oldalra.",
        },
        webName: "Weboldal neve",
        apiKey: "API kulcs",
        heureka: {
          title: "Összekapcsolás a Heurekával",
          description:
            "Az értesítés aktiválásához Heureka API-kulcs szükséges. Szeretné hozzáadni az API-kulcsot?",
          heurekaApiKey: "Heureka API kulcs",
          country: "Ország",
          stars: "csillag",
          reviewsWithRating: "Értékelések több mint",
          maxReviews: "Értékelések minimális száma a megjelenítéshez",
          howToAddApiKey: {
            title: "Heureka kulcs hozzáadása",
            first:
              "A Heureka-fiókjában válassza ki a felső menüből a webáruház Adminisztráció menüpontját.",
            second:
              "A bal oldali menüben válassza ki a Vásárlók által ellenőrzött menüpontot.",
            third:
              "Másolja ki a titkos kulcsot, és illesszék be az API-kulcs mezőbe.",
            thirdHelp:
              'A kulcs akkor érhető el, ha elegendő értékeléssel rendelkezik, és megfelel a "Vásárlók által ellenőrzött" feltételeknek.',
            fourth: "Ellenőrizze az állapotot",
          },
        },
        zbozi: {
          title: "Összekapcsolás a Zboží.cz-vel",
          description:
            "Az értesítés aktiválásához a Zboží.cz API-kulcsára van szükség. Szeretné hozzáadni az API-kulcsot?",
          howToAddKey: "Zboží.cz API-kulcs hozzáadása",
          shopId: "Üzlet azonosító",
          storeReview: "üzlet értékelése",
          productReview: "termék értékelése",
          maxReviews: "Értékelések minimális száma a megjelenítéshez",
          howToAddApiKey: {
            title: "Sklik API-kulcs hozzáadása",
            first:
              "Jelentkezzen be Sklik fiókjába a sklik.cz oldalon, és a felső menüben válassza a Beállítások lehetőséget.",
            second:
              "A bal oldali menüben keresse meg az API-kulcsok részt, és kattintson a Kulcs hozzáadása gombra.",
            third:
              "Adjon nevet a kulcsnak, másolja ki a létrehozott refresh tokent, és illessze be a fenti API-kulcs mezőbe. Az üzlet azonosítója mezőbe adja meg Zboží.cz fiókjának létesítmény-azonosítóját (ID provozovny).",
            thirdHelp:
              "A Zboží.cz API-t az új Sklik API váltotta fel. Az üzlet azonosítója (ID provozovny) változatlan marad – megtalálja Zboží.cz fiókjában a Létesítmény részben.",
            fourth: "Ellenőrizze az állapotot az Ellenőrzés gomb segítségével.",
          },
        },
        spolehlivaRecenze: {
          title: "Összekapcsolás a Spolehlivé Recenze-vel",
          description:
            "Az értesítés aktiválásához be kell jelentkezni a Spolehlivé Recenze-be. Be szeretne jelentkezni?",
          howToAddApiKey: {
            title: "Hogyan jelentkezzen be a Spolehlivé Recenze-be",
            first:
              "Másolja ki a shopid-et és a jelszót a fiókjából a Spolehlivé Recenze-ből.",
            second:
              "Írja be a következő információkat a megfelelő fenti mezőkbe.",
            third: "Ellenőrizze az állapotot.",
          },
        },
        googleReviews: {
          title: "Kapcsolódás a Google értékelésekhez",
          apiKey: "API kulcs",
          searchPlace: "Keresse meg vállalkozását a Google Térképen",
          placeId: "Hely azonosító",
          companyName: "Cég neve",
          description:
            "Az értesítés aktiválásához ki kell töltenie a Hely azonosítót, amelyet a Google Térképen lévő vállalkozások keresési mezőjével találhat meg.",
          howToAddApiKey: {
            title: "Hogyan adhat hozzá Google értékeléseket",
            first:
              "A Keresse meg vállalkozását mezőben javasoljuk, hogy ugyanazt a nevet adja meg, amely a Google Térképen szerepel.",
            second:
              "A keresőablakban válassza ki azt a vállalkozását, amely az értékelések forrásául szolgál. A Hely azonosító mező automatikusan kitöltődik",
            third: "Ellenőrizze az állapotot.",
          },
          maxReviews: "Megjelenítendő értékelések minimális száma",
          reviewsWithRating: "Értékelések több mint",
          stars: "csillaggal",
          noOptions: "Nincsenek opciók",
        },
        trustPilot: {
          title: "Összekapcsolás a TrustPilot-tal",
          description:
            "Az értesítés aktiválásához TrustPilot API kulcs és Business Unit ID szükséges. Szeretné hozzáadni az API kulcsot?",
          howToAddApiKey: {
            title: "Hogyan adja hozzá a TrustPilot azonosítót",
            first: "Látogassa meg a TrustPilot üzleti oldalát",
            second:
              "Másolja ki a nevet az URL-ből. A https://trustpilot.com/review/cegem-neve címből csak a cegem-neve részt másolja ki",
            third: "Írja be ezt a nevet a fenti mezőbe",
          },
          minReviews: "Megjelenítendő értékelések minimális száma",
          reviewsWithRating: "Értékelések több mint",
          stars: "csillaggal",
        },
      },
      pairing: {
        title: "Csatlakozás",
        collectData: "Adatrögzítés",
        addCondition: "Feltétel hozzáadása",
        cantEdit: "Nem szerkeszthető",
        pairingCondition: "Párosítási szabály",
        selectedDomain: "Kiválasztott domain",
        pageVisitors: "Az egyes oldalak látogatói",
        domainVisitors: "Az egész domain látogatóinak összefoglalásai",
        campaignCollects:
          "A kampány minden egyes oldal látogatóit külön-külön rögzíti.",
      },
      design: {
        title: "Kinézet",
        description:
          "Az alapértelmezett kinézet az egész kampányra van beállítva, itt testre szabhatja egy adott értesítéshez.",
        backgroundColor: "Háttérszín",
        textColor: "Szöveg színe",
        iconbackgroundColor: "Ikon háttérszíne",
        iconColor: "Ikon színe",
        roundedCorners: "Sarkok lekerekítése",
        icon: "Ikon",
      },
    },
    deleteModal: {
      title: "Értesítések törlése?",
      description: "Minden adat törlésre kerül.",
    },
    lastOrders: {
      title: "Utolsó megrendelések",
      description:
        "Heti 10 vagy több megrendeléssel rendelkező webáruházak számára ajánlott.",
      previewText1: "Kassai József",
      previewText2: "befejezte a megrendelést",
    },
    lastRegistrations: {
      title: "Utolsó regisztrációk",
      description: "Ajánlott kereslet- és a kapcsolatgyűjtő oldalak számára.",
      previewText1: "Kassai József",
      previewText2: "befejezte a regisztrációt",
    },
    actualVisitors: {
      title: "Látogatottság - aktuális statisztikák",
      description:
        "Legalább napi 1 000 látogatóval rendelkező oldalak számára ajánlott.",
      previewText1: "látogatók",
    },
    visitorSummary: {
      title: "Látogatottság - összefoglaló statisztikák",
      description:
        "Napi 1 000 látogatónál kevesebbel rendelkező oldalak számára ajánlott.",
      previewText1: "látogatók",
      previewText2: "felhasználók",
    },
    registrationSummary: {
      title: "Regisztrációk - összefoglaló statisztikák",
    },
    orderSummary: {
      title: "Látogatottság - összefoglaló statisztikák",
    },
    heureka: {
      title: "Heuréka - vélemények és értékelések",
      description:
        "Olyan webáruházak számára ajánlott, amelyek pozitív szöveges értékelésekkel rendelkeznek a Heurekán",
      previewText1:
        "A 12 pro maxhoz képest nagyra értékelem a csodálatos kamerát (a 4k videók kiválóak) és a fényképeket is - hatalmas különbség és fejlődés. Kiváló makró. Gyors és megbízható telefon. Nagy elégedettség. A szín gyönyörű.",
      previewText2: "ajánlja",
    },
    zbozi: {
      title: "Zboží - vélemények és értékelések",
      description:
        "Olyan webáruházak számára ajánlott, amelyek pozitív szöveges értékelésekkel rendelkeznek a Zboží.cz oldalon",
      previewText1:
        "A 12 pro maxhoz képest nagyra értékelem a csodálatos kamerát (a 4k videók kiválóak) és a fényképeket is - hatalmas különbség és fejlődés. Kiváló makró. Gyors és megbízható telefon. Nagy elégedettség. A szín gyönyörű.",
      previewText2: "ajánlja",
    },
    individual: {
      title: "Egyéni",
      description:
        "Csatoljon tetszés szerinti szöveget az értesítéshez. Nagyszerű eszköz a kedvezmények, az ingyenes szállítás és a termékekkel, szolgáltatásokkal kapcsolatos egyéb előnyök közlésére.",
      previewText1:
        "Iratkozzon fel a webáruházunkba, és 5% kedvezményt kap a vásárlására.",
      previewText2: "Kapjon ajándékot",
    },
    shoptetLastOrders: {
      title: "Utolsó Shoptet megrendelések",
      description:
        "Exkluzív értesítések a Shoptet platformot használó webáruházak számára.",
      timeRange: "Időtartomány",
      showRandom: "Véletlenszerű rendelések megjelenítése az utolsó ",
      twoMonths: "2 hónap",
      screwdriver: "Csavarhúzó",
    },
    eshopRychleLastOrders: {
      title: "Utolsó Eshop-rychle megrendelések",
      description:
        "Exkluzív értesítések az Eshop-rychle platformot használó webáruházak számára.",
      timeRange: "Időtartomány",
      showRandom: "Véletlenszerű rendelések megjelenítése az utolsó ",
      twoMonths: "2 hónap",
      screwdriver: "Csavarhúzó",
    },
    shoptetCouponCode: {
      title: "Shoptet kedvezménykód",
      description:
        "Exkluzív értesítések a Shoptet platformot használó webáruházak számára.",
      info: "Az értesítés feltételezi, hogy Ön rendelkezik kedvezmény kuponnal a shoptet platformon, amelyre vonatkozóan itt kitöltötte az adatokat.",
      code: "Kedvezménykód",
      saleType: "Kedvezmény értéke",
      saleIn: "Kedvezmény ebben:",
      saleOn: "Kedvezmény erre:",
      wholeSale: "Teljes vásárlás",
      sale10: "KEDVEZMÉNY10",
      previewText:
        'Használja a "KEDVEZMÉNY10" kódot és kapjon 10% kedvezményt a teljes vásárlásra.',
    },
    shopifyLastOrders: {
      title: "Utolsó rendelések Shopify-hoz",
      description: "Exkluzív értesítések a Shopify platformot használó webáruházak számára.",
      timeRange: "Időtartomány",
      showRandom: "Véletlenszerű rendelések megjelenítése az utolsó",
      twoMonths: "2 hónap",
      screwdriver: "iPhone 15 Pro",
    },
    spolehlivaRecenzeShopRating: {
      title: "Spolehlivé recenze - vélemények és értékelések",
      description:
        "Olyan webáruházak számára ajánlott, amelyek pozitív szöveges értékelésekkel rendelkeznek a spolehliverecenze.cz oldalon",
      previewText1:
        "A vásárlás ebben a webáruházban csodálatos volt. A rendelés gyorsan megérkezett, és az áru felülmúlta az elvárásaimat. Kiváló ügyfélszolgálat, biztosan újra vásárolok!",
    },
    spolehlivaRecenzeProductRating: {
      title: "Spolehlivé recenze - vélemények és értékelések",
      description:
        "Olyan webáruházak számára ajánlott, amelyek pozitív szöveges értékelésekkel rendelkeznek a spolehliverecenze.cz oldalon",
      previewText1:
        "Ez a termék teljesen fantasztikus! A kidolgozás minősége magas színvonalú, pontosan a leírás szerint működik, és az ár-érték arány kiváló. Csak ajánlani tudom.",
    },
    googleReviews: {
      title: "Google Értékelések - vélemények és értékelések",
      description:
        "Ajánlott olyan e-shopok számára, amelyek pozitív szöveges értékelésekkel rendelkeznek a Google-on",
      previewText1:
        "A 12 pro maxhoz képest nagyra értékelem a csodálatos kamerát (a 4k videók kiválóak) és a fényképeket is - hatalmas különbség és fejlődés. Kiváló makró. Gyors és megbízható telefon. Nagy elégedettség. A szín gyönyörű.",
      previewText2: "ajánlja",
    },
    trustPilot: {
      title: "TrustPilot - vélemények és értékelések",
      description:
        "Ajánlott olyan e-shopok számára, amelyek pozitív szöveges értékelésekkel rendelkeznek a TrustPilot-on",
      previewText1:
        "Nagyszerű üzlet, tökéletes ügyfélszolgálattal. Az áru gyorsan és rendben megérkezett. A kommunikáció problémamentes és gyors volt. Csak ajánlani tudom, biztosan újra vásárolok.",
      previewText2: "ajánlja",
    },
  },
  branding: {
    title: "Márkázás",
    sizeAndForm: {
      title: "Értesítés mérete és formája",
      classic: "Klasszikus",
      small: "Alacsony",
      compact: "Kompakt",
    },
    defaultSettings: {
      title: "Alapbeállítások",
      backgroundColor: "Háttérszín",
      textColor: "Szövegszín",
      backgroundOpacity: "Háttér átlátszósága",
      borderRadius: "Szegély lekerekítése",
    },
    icons: {
      title: "Ikonok megjelenítése",
      iconColor: "Ikon színe",
      backgroundColor: "Ikon háttérszíne",
      backgroundRadius: "Ikon háttér lekerekítése",
    },
  },
  analytics: {
    title: "Adatelemzés",
    lastOrders: "Legutóbbi rendelések",
    lastRegistrations: "Legutóbbi regisztrációk",
    updateData: "Adatok frissítése",
    dateAndTime: "Dátum és idő",
    customerName: "Ügyfél neve",
    customerLocation: "Ügyfél helye",
  },
  standardSettingsModal: {
    title: "A megjelenés visszaáll az alapértelmezett beállításokra",
    description: "Minden változtatása felül lesz írva.",
    applyButton: "Alapértelmezett beállítások alkalmazása",
    closeButton: "Bezárás",
  },
};
